export default __webpack_public_path__ + "static/media/74_photo.28fb4733.jpg";